import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "11 17 6 12 11 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "18 17 13 12 18 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronsLeft";
const ChevronsLeft = memo(themed(Icon));
export {
  ChevronsLeft
};
//# sourceMappingURL=chevrons-left.js.map
